import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getGasEquipmentParts } from '../thunks/partsThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearPartsKey } from '../thunkKeys/partsThunksKeys';

const SLICE_NAME = 'gasEquipmentParts';

export const gasEquipmentPartsSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearGasEquipmentParts(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getGasEquipmentParts });
        builder.addCase(clearPartsKey, () => commonInitialState);
    },
});

export const { clearGasEquipmentParts } = gasEquipmentPartsSlice.actions;

export const gasEquipmentParts = gasEquipmentPartsSlice.reducer;
